var youbora = require('youboralib')
var manifest = require('../../manifest.json')

var AdsAdapter = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    if (this.player) {
      return this.player.getPlayheadTime()
    }
    return this.playhead
  },

  /** Override to return video duration */
  getDuration: function () {
    if (this.player) {
      return this.player.getDuration()
    }
    return this.duration
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    if (this.player) {
      return this.player.getCurrentBitrate()
    }
    return this.bitrate
  },

  /** Override to return rendition */
  getRendition: function () {
    return this.rendition
  },

  /** Override to return title */
  getTitle: function () {
    if (this.player) {
      return this.player.getTitle()
    }
    return this.title
  },

  /** Override to return resource URL. */
  getResource: function () {
    return "unknown"
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return OO.VERSION.core.rev
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return "Ooyala"
  },

  getPosition: function () {
    if (this.plugin._adapter.getPlayhead() === this.plugin._adapter.getDuration()) {
      return 'post'
    } else if (!this.plugin._adapter.getPlayhead()) {
      return 'pre'
    }
    return 'mid'
  },

  processEvent: function (eventName, params) {
    try {
      // if (eventName !== "video_stream_position_changed") youbora.Log.debug(eventName)
      switch (eventName) {
        case "video_stream_position_changed":
          this.playhead = params[0].streamPosition
          this.duration = params[0].totalStreamDuration
          if (this.flags.isPaused && (this.playhead > this.clickPlayhead + 1)) {
            this.clickPlayhead = null
            this.fireResume()
          }
          break
        case "ad_started":
          this.playhead = 0
          if (params[0].adMetadata) {
            this.duration = params[0].adMetadata.adDuration
            this.title = params[0].adMetadata.adId
          }
          this.fireStart()
          this.monitorPlayhead(true, false, 1200)
          break
        case "ad_pod_ended":
        case "ad_break_ended":
          this.plugin._adapter.isShowingAds = false
          this.plugin._adapter.fireResume()
        case "ad_ended":
        case "adCompleted":
          this.fireStop()
          break
        case "ad_skipped":
          this.fireStop({ skipped: true })
          break
        case "video_playing":
        case "ad_impression":
          this.fireJoin()
          this.fireResume()
          break
        case "video_paused":
          this.firePause()
          break
        case "video_content_metadata_updated":
          this.title = params[0].title
          this.duration = params[0].duration / 1000
          break
        case "bitrateInitial":
          this.bitrate = params[0].bitrate
          if (isNaN(params[0].id)) {
            this.rendition = params[0].id
          } else if (params[0].width && params[0].height && params[0].bitrate) {
            this.rendition = youbora.Util.buildRenditionString(params[0].width, params[0].height, params[0].bitrate)
          } else {
            this.rendition = null
          }
          break
        case "ad_error":
          this.fireError("ad_error", params[0].error)
          this.fireStop()
          this.playhead = 0
          this.plugin._adapter.isShowingAds = false
          break
        case "ad_clickthrough_opened":
          this.clickPlayhead = this.playhead
          this.fireClick()
          this.firePause()
          break
      }
    } catch (error) {
      youbora.Log.error(error)
    }

  }
})

module.exports = AdsAdapter



//////////////////
// WEBPACK FOOTER
// ./src/ads/adsadapter.js
// module id = 51
// module chunks = 0